import React from 'react';
import PropTypes from 'prop-types';
import {
    Divider,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Typography
} from '@mui/material';
import MobileBottomSheet from './MobileBottomSheet';

export const sectionLabelSx = {
    display: 'block',
    px: 2,
    pb: 0.5,
    fontWeight: 700,
    color: 'text.secondary',
    textTransform: 'uppercase',
    letterSpacing: '.4px'
};

// A list of actions in a bottom sheet: the phone's page ⋮ menu. Items are plain
// descriptors, so the caller keeps its permission checks; `type: 'divider'`
// starts a section, with an optional caption.
export default function MobileActionsSheet({ open, onClose, title, items }) {
    return (
        <MobileBottomSheet open={open} onClose={onClose} title={title}>
            <List disablePadding>
                {items.map((item) =>
                    item.type === 'divider' ? (
                        <React.Fragment key={item.key}>
                            <Divider sx={{ my: 1 }} />
                            {item.label && (
                                <Typography variant="caption" sx={sectionLabelSx}>
                                    {item.label}
                                </Typography>
                            )}
                        </React.Fragment>
                    ) : (
                        <ListItemButton
                            key={item.key}
                            disabled={item.disabled}
                            onClick={() => {
                                onClose();
                                item.onClick();
                            }}
                            sx={{
                                minHeight: (theme) => theme.sizes.touchTarget,
                                borderRadius: (theme) =>
                                    `${theme.shape.menuItem}px`,
                                color: item.color
                            }}
                        >
                            {item.icon && (
                                <ListItemIcon sx={{ color: 'inherit' }}>
                                    {item.icon}
                                </ListItemIcon>
                            )}
                            <ListItemText
                                primary={item.label}
                                primaryTypographyProps={{ fontWeight: 600 }}
                            />
                        </ListItemButton>
                    )
                )}
            </List>
        </MobileBottomSheet>
    );
}

MobileActionsSheet.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string.isRequired,
            type: PropTypes.oneOf(['divider']),
            label: PropTypes.node,
            icon: PropTypes.node,
            color: PropTypes.string,
            disabled: PropTypes.bool,
            onClick: PropTypes.func
        })
    ).isRequired,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    title: PropTypes.node
};
